import React from "react";
import PropTypes from "prop-types";
import { useSelector } from "react-redux";
import selectors from "selectors";
import Message from "./message";

const MessageList = ({ messages, readReceipts, scrollRef }) => {
  const internalRef = React.useRef();
  const userId = useSelector(selectors.getUserId);
  const lastOwnMessage = [...messages].reverse().find(msg => msg.author === userId);

  React.useEffect(() => {
    const container = scrollRef?.current || internalRef.current;
    if (container) {
      container.scrollTop = container.scrollHeight;
    }
  }, [messages, scrollRef]);

  return (
    <div
      className="messages-container"
      ref={internalRef}
      role="log"
      aria-live="polite"
      aria-atomic="false"
      aria-relevant="additions"
      aria-label="Chat messages"
    >
      {messages.map((msg, i) => (
        <Message
          key={msg.index ?? i}
          {...msg}
          userId={userId}
          isLastOwnMessage={msg === lastOwnMessage}
          readInfo={readReceipts}
        />
      ))}
    </div>
  );
};

MessageList.propTypes = {
  messages: PropTypes.arrayOf(PropTypes.object).isRequired,
  readReceipts: PropTypes.object,
  scrollRef: PropTypes.object
};

export default MessageList;
